import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import Select from 'react-select';
import { sortInAlphabeticalOrder } from '../common-helpers/commonServices';


import TinyEditor from '../Common-Components/TinyEditor';
import { validateQuizQuestionData } from '../CommonHelper';
import '../Course/Course.css';
import { generateUniqueID } from '../Course/CourseHelper';
import { set } from 'date-fns';
import DropdownInput from '../Common-Components/DropdownInput';
// import SubjectAndSectionDropdown from './SubjectAndSectionDropdown';

let initialFormData = {
    examType: 'Section-IA',
    sn: 0,
    subjectType: 'Select Subject Type',
    subjectId: 0,
    section: 'Select TOPICS',
    sectionId: 0,
    topic: 'Select SUB TOPIC',
    topicId: 0,
    question: '',
    option1: '',
    option2: '',
    option3: '',
    option4: '',
    subjectId: 0,
    sectionId: 0,
    correctAnswer: 'Select Correct Answer',
    description: '',
    quizId: '',
}
const CUET_QuestionBankModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    useImperativeHandle(ref, () => ({
        openModal(questionData = {}) {
            setModalBox(true);
            if (questionData.sn > 0) {
                setFormData(questionData)
            } else {
                setFormData({
                    ...initialFormData,
                    ...questionData,
                    quizId: generateUniqueID()
                });
            }
        }
    }));

    const handleChange = (name, value) => {
        setFormData((previousData) => ({
            ...previousData,
            [name]: value
        }));
    };
    console.log(formData)
    const handleSubmitTest = () => {
        let errorMessgae = validateQuizQuestionData(formData);

        if (errorMessgae) {
            toast.error(errorMessgae)
            return;
        }
        axios.post(BACKEND_SERVER_URL + (formData.sn > 0 ? `/cuet/updateQuestion` : '/cuet/createQuestion'), formData).then((response) => {
            if (response.data.statusCode == 200) {
                setFormData(initialFormData)
                toast.success(response.data.message)
                props.setLoadQuestions(!props.loadQuestions);
                props.setQuestionOffset(1); // Reset question offset to 1 after successful submission
                setModalBox(false);
            }
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setFormData(initialFormData); // Reset form data when modal is closed
        }
    }, [modalBox]);


    const [subjects, setSubjects] = useState([]);
    const [sections, setSections] = useState([]);
    const [topics, setTopics] = useState([]);
    console.log(topics);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    const [selectedTopics, setSelectedTopics] = useState([]);
    useEffect(() => {
        if (!modalBox) {
            return;
        }
        const response = axios.all([
            axios.get(BACKEND_SERVER_URL + '/cuet/subjects'),
            axios.get(BACKEND_SERVER_URL + '/cuet/sections'),
            axios.get(BACKEND_SERVER_URL + '/cuet/topics')
        ]);
        console.log(response);
        response.then(axios.spread((subjectsResponse, sectionsResponse, topicsResponse) => {
            let subjects = subjectsResponse.data.subjects;
            let sections = sectionsResponse.data.sections;
            let topics = topicsResponse.data.topics;
            console.log(sections);
            setSubjects(sortInAlphabeticalOrder(subjects, 'SubjectType'));
            const selectedSubjects = subjects.filter(subject => subject.ExamType == formData.examType);
            setSelectedSubjects(sortInAlphabeticalOrder(selectedSubjects, 'SubjectType'));
            setSections(sortInAlphabeticalOrder(sections, 'Section'));
            setTopics(sortInAlphabeticalOrder(topics, 'Topic'));
        })).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects and sections.");
        });

    }, [modalBox])

    useEffect(() => {
        // for editing the question or pre-filling new questions, we need to set the dropdown options
        if (formData.examType) {
            let filteredSubjects = subjects.filter(subject => subject.ExamType == formData.examType);
            setSelectedSubjects(sortInAlphabeticalOrder(filteredSubjects, 'SubjectType'));
        }
        if (formData.subjectId > 0) {
            let filteredSections = sections.filter(section => section.SubjectTypeID == formData.subjectId);
            setSelectedSections(sortInAlphabeticalOrder(filteredSections, 'Section'));
        }
        if (formData.sectionId > 0) {
            let filteredTopics = topics.filter(topic => topic.SectionID == formData.sectionId);
            setSelectedTopics(sortInAlphabeticalOrder(filteredTopics, 'Topic'));
        }
    }, [formData.examType, formData.subjectId, formData.sectionId, subjects, sections, topics]);

    const selectExamTypeHandler = (selectedExamType) => {
        setFormData((previousData) => ({
            ...previousData,
            examType: selectedExamType,
        }));
        let filteredSubjects = subjects.filter(subject => subject.ExamType == selectedExamType);
        setSelectedSubjects(sortInAlphabeticalOrder(filteredSubjects, 'SubjectType'));
    }

    const selectSubjectTypeHandler = (selectedSubjectType) => {
        setFormData((previousData) => ({
            ...previousData,
            subjectType: selectedSubjectType.SubjectType,
            subjectId: selectedSubjectType.Sn,
        }));
        let filteredSections = sections.filter(subject => subject.SubjectTypeID == selectedSubjectType.Sn);
        setSelectedSections(sortInAlphabeticalOrder(filteredSections, 'Section'));
    }
    const selectSectionHandler = (selectedSection) => {
        setFormData((previousData) => ({
            ...previousData,
            section: selectedSection.Section,
            sectionId: selectedSection.Sn,
        }));
        let filteredTopics = topics.filter(topic => topic.SectionID == selectedSection.Sn);
        setSelectedTopics(sortInAlphabeticalOrder(filteredTopics, 'Topic'));
    }
    const selectTopicHandler = (selectedTopic) => {
        setFormData((previousData) => ({
            ...previousData,
            topic: selectedTopic.Topic,
            topicId: selectedTopic.Sn,
        }));
    }
    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{formData.sn > 0 ? 'Update Question' : 'Create Question'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">All SUBJECT<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={(() => {
                                                    const options = [
                                                        { value: 'Section-IA', label: 'Language Subjects' },
                                                        { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                                        { value: 'Section-III', label: 'General Aptitude Test' }
                                                    ];
                                                    return options.find(opt => opt.value === formData.examType) || { value: formData.examType, label: formData.examType };
                                                })()}
                                                onChange={(selectedOption) => {
                                                    setFormData({ ...formData, examType: selectedOption.value });
                                                    setSelectedSubjects(subjects.filter((subject) => subject.ExamType === selectedOption.value));
                                                }}
                                                options={[
                                                    { value: 'Section-IA', label: 'Language Subjects' },
                                                    { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                                    { value: 'Section-III', label: 'General Aptitude Test' }
                                                ]}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        backgroundColor: 'transparent', // Adjust as needed
                                                        borderColor: '#17a2b8', // Adjust as needed

                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.subjectType, label: formData.subjectType }}
                                                onChange={(selectedOption) => selectSubjectTypeHandler(selectedOption.value)}
                                                options={selectedSubjects?.map((subject) => ({ value: subject, label: subject.SubjectType }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        backgroundColor: 'transparent', // Adjust as needed
                                                        borderColor: '#17a2b8', // Adjust as needed

                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">TOPICS<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                isDisabled={selectedSubjects.length == 0}
                                                value={{ value: formData.section, label: formData.section }}
                                                onChange={(selectedOption) => selectSectionHandler(selectedOption.value)}
                                                options={selectedSections?.map((section) => ({ value: section, label: section.Section }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        backgroundColor: 'transparent', // Adjust as needed
                                                        borderColor: '#17a2b8', // Adjust as needed

                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">SUB TOPIC<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                isDisabled={selectedSubjects.length == 0}
                                                value={{ value: formData.topic, label: formData.topic }}
                                                onChange={(selectedOption) => selectTopicHandler(selectedOption.value)}
                                                options={selectedTopics?.map((section) => ({ value: section, label: section.Topic }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        backgroundColor: 'transparent', // Adjust as needed
                                                        borderColor: '#17a2b8', // Adjust as needed

                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor key={`question-${formData.sn || formData.quizId}`} handleChangeCallBack={handleChange} labelName="Question Content" inputValue={formData?.question} inputName='question' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor key={`opt1-${formData.sn || formData.quizId}`} handleChangeCallBack={handleChange} labelName="Option (A)" inputValue={formData?.option1} inputName='option1' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor key={`opt2-${formData.sn || formData.quizId}`} handleChangeCallBack={handleChange} labelName="Option (B)" inputValue={formData?.option2} inputName='option2' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor key={`opt3-${formData.sn || formData.quizId}`} handleChangeCallBack={handleChange} labelName="Option (C)" inputValue={formData?.option3} inputName='option3' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor key={`opt4-${formData.sn || formData.quizId}`} handleChangeCallBack={handleChange} labelName="Option (D)" inputValue={formData?.option4} inputName='option4' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor key={`desc-${formData.sn || formData.quizId}`} handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.description} inputName='description' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <div className="col-5 d-flex ms-4">
                                        <DropdownInput handleChangeCallBack={handleChange} labelName="Correct Answer" selectedValue={formData?.correctAnswer} inputName='correctAnswer' dropdownValuesArray={['A', 'B', 'C', 'D']} />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitTest}>{formData.sn > 0 ? 'Update Question' : 'Create Question'}</Button>
                </Modal.Footer>
            </Modal>

        </>
    )
})
export default CUET_QuestionBankModal;